import { Component, Input } from "@angular/core";
import { Location } from "@angular/common";

@Component({
  standalone: false,
  selector: 'app-title',
  templateUrl: 'title.component.html',
  styleUrls: ['title.component.scss']
})
export class TitleComponent {
  @Input()
  title!: string;

  constructor(private location: Location) {
  }

  onBack() {
    this.location.back();
  }
}
